import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import currencyFormat from 'src/utils/formatCOP';
import onMouseResultsMap from 'src/utils/onMouseResultsMap';
import { useStyles, StyledTableCell } from '../reportsBoard/styles';
import LoadingRows from './LoadingRows';

const TableAAPPMEI = ({
  array = [], selectedDate, title, param,
}) => {
  const classes = useStyles();

  return (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} size="small" aria-label="spanning table">
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={6} align="center">
                Unidades Enero - Diciembre
              </StyledTableCell>
              <StyledTableCell colSpan={5} align="center">
                Pesos Enero - Diciembre
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell align="center">{title}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear()}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear() - 1}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear() - 2}</StyledTableCell>
              <StyledTableCell align="right">AA</StyledTableCell>
              <StyledTableCell align="right">AAA</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear()}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear() - 1}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear() - 2}</StyledTableCell>
              <StyledTableCell align="right">%AAA</StyledTableCell>
              <StyledTableCell align="right">%AAA</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {array.length > 0 ? (
              array.map((row) => (
                <TableRow key={Math.random()}>
                  <TableCell align="left">{row[param].toUpperCase()}</TableCell>
                  <TableCell align="right">{currencyFormat(parseInt(row.PERIODO1, 10))}</TableCell>
                  <TableCell align="right">{currencyFormat(parseInt(row.PERIODO2, 10))}</TableCell>
                  <TableCell align="right">{currencyFormat(parseInt(row.PERIODO3, 10))}</TableCell>
                  <TableCell align="right">
                    {(+row.AA).toFixed(2)}
                    %
                  </TableCell>
                  <TableCell align="right">
                    {(+row.SELLIN_AAA).toFixed(2)}
                    %
                  </TableCell>
                  <TableCell align="right">{+row.P1}</TableCell>
                  <TableCell align="right">{+row.P2}</TableCell>
                  <TableCell align="right">{+row.P3}</TableCell>
                  <TableCell align="right">{(+row.DELTA_PESO).toFixed(2)}</TableCell>
                  <TableCell align="right">{(+row.SELLOUT_AAA).toFixed(2)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                  <TableCell><LoadingRows /></TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>TOTAL</TableCell>
              <TableCell align="right">{onMouseResultsMap.totals(array, 'PERIODO1')}</TableCell>
              <TableCell align="right">{onMouseResultsMap.totals(array, 'PERIODO2')}</TableCell>
              <TableCell align="right">{onMouseResultsMap.totals(array, 'PERIODO2')}</TableCell>
              <TableCell align="right"> </TableCell>
              <TableCell align="right"> </TableCell>
              <TableCell align="right">{onMouseResultsMap.totals(array, 'P1')}</TableCell>
              <TableCell align="right">{onMouseResultsMap.totals(array, 'P2')}</TableCell>
              <TableCell align="right">{onMouseResultsMap.totals(array, 'P3')}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableAAPPMEI;
